var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// breakpoints.js
export var breakpoints = {
    small: 320,
    medium: 768,
    large: 1024,
    xlarge: 1160,
    largest: 1520
};
var mediumAndLargerScreenMargin = 24 * 2;
var minWidthQueries = {
    medium: {
        minWidth: breakpoints.medium - mediumAndLargerScreenMargin
    },
    large: {
        minWidth: breakpoints.large - mediumAndLargerScreenMargin
    },
    xlarge: {
        minWidth: breakpoints.xlarge - mediumAndLargerScreenMargin
    },
    largest: {
        minWidth: breakpoints.largest - mediumAndLargerScreenMargin
    }
};
var maxWidthQueries = {
    'less-than-medium': {
        maxWidth: breakpoints.medium - mediumAndLargerScreenMargin - 1
    },
    'less-than-large': {
        maxWidth: breakpoints.large - mediumAndLargerScreenMargin - 1
    },
    'less-than-xlarge': {
        maxWidth: breakpoints.xlarge - mediumAndLargerScreenMargin - 1
    },
    'less-than-largest': {
        maxWidth: breakpoints.largest - mediumAndLargerScreenMargin - 1
    }
};
/**
 * used for container queries
 */
export var query = __assign(__assign({}, minWidthQueries), maxWidthQueries);
/**
 * Function to create common media query for responsive
 * CSS rules. Pass in a number or a pre-determined
 * label for the breakpoints object
 *
 * @example
 *
 *  const foo = styled.div`
 *    font-size: 12px;
 *
 *    ${breakpoint('small')} {
 *      font-size: 14px;
 *    }
 *  `
 *
 * @param {string|number} bp
 * @param {string} type 'up' (min-width) or 'down' (max-width)
 * @returns {string} css rule
 */
export var createMediaQuery = function (bp, type) {
    if (bp === void 0) { bp = 'small'; }
    if (type === void 0) { type = 'up'; }
    var adjustment = type === 'down' ? -1 : 0;
    return "@media only screen and (".concat(type === 'up' ? 'min' : 'max', "-width: ").concat(breakpoints[bp] + adjustment, "px)");
};
/**
 * Function to create a container query for responsive CSS rules.
 * Pass in a pre-determined label from the breakpoint object
 * and optionally pass in a type for a min-width or max-width rule.
 *
 * A parent element must be declared as a container
 * with a CSS rule `container-type: inline-size`.
 *
 * @example
 *
 *  const foo = styled.div`
 *    font-size: 12px;
 *
 *    ${breakpoint('small', {mode: "containerV2"})} {
 *      font-size: 14px;
 *    }
 *  `
 *
 * @param {string|number} bp
 * @param {string} type 'up' (min-width) or 'down' (max-width)
 * @returns {string} css rule
 */
export var createContainerQuery = function (bp, type) {
    if (bp === void 0) { bp = 'small'; }
    if (type === void 0) { type = 'up'; }
    var adjustment = type === 'down' ? -1 : 0;
    return "@container (".concat(type === 'up' ? 'min' : 'max', "-width: ").concat(breakpoints[bp] + adjustment, "px)");
};
/**
 * Returns a media query for screen size, or a class name for querying a container size
 *
 * if screen - @example `@media only screen and (min-width: 768px)`
 * if containerV2 - @example `@container (min-width: 768px)`
 * if container - @example `BOM_small_container_query`
 */
var breakpoint = function (size, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.mode, mode = _c === void 0 ? 'screen' : _c, _d = _b.type, type = _d === void 0 ? 'up' : _d;
    if (!breakpoints[size])
        throw new Error('Invalid size passed to breakpoint');
    if (mode === 'screen')
        return createMediaQuery(size, type);
    if (mode === 'container') {
        if (type === 'down')
            return ".less-than-".concat(size, " &, &.less-than-").concat(size);
        return ".".concat(size, " &, &.").concat(size);
    }
    if (mode === 'containerV2')
        return createContainerQuery(size, type);
    return null;
};
export default breakpoint;
